import * as React from 'react';
import { ISchedule } from '../../../../../../common/constants';
import { Edit, Trash, Close } from '../../../../../../components/Icons';

interface ICardProps {
    index: number;
    editingIndex: number | null;
    schedule: ISchedule;
    handleTimeChange: (index: number, time: string) => void;
    handleValueChange: (index: number, value: number) => void;
    handleSaveEdit: (index: number) => void;
    handleCancelEdit: () => void;
    handleDelete: (index: number) => void;
    handleEdit: (index: number) => void;
    validateTimeFormat: (time: string) => boolean;
}

const Card: React.FunctionComponent<ICardProps> = ({
  index,
  editingIndex,
  schedule,
  handleTimeChange,
  handleValueChange,
  handleSaveEdit,
  handleCancelEdit,
  handleDelete,
  handleEdit,
  validateTimeFormat
}) => {
  return (
    <div key={index} className="bg-gray-50 rounded-lg transition-all duration-300 hover:shadow-md">
      {editingIndex === index ? (
        // Edit mode
        <div className="px-5">
          <div className="flex gap-3 mb-4">
            <input
              type="time"
              step="60"
              className="flex-1 border border-gray-300 rounded-md px-3 py-2 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-200"
              value={schedule.time}
              onChange={(e) => handleTimeChange(index, e.target.value)}
              style={{ 
                '--webkit-calendar-picker-indicator-color': '#3b82f6',
                '--webkit-calendar-picker-indicator-hover-color': '#2563eb'
              } as React.CSSProperties}
            />
            <input
              type="number"
              className="flex-1 border border-gray-300 rounded-md px-3 py-2 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-200"
              min="0"
              max="100"
              value={schedule.value}
              onChange={(e) => handleValueChange(index, parseInt(e.target.value) || 0)}
              placeholder="Giá trị (%)"
            />
          </div>
          <div className="flex gap-3 justify-end">
            <button 
              className="bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400 text-white px-4 py-2 rounded-md font-semibold transition-all duration-300 disabled:cursor-not-allowed"
              onClick={() => handleSaveEdit(index)}
              disabled={!validateTimeFormat(schedule.time)}
            >
              <span>Lưu</span>
            </button>
            <button 
              className="border border-gray-300 hover:bg-gray-100 text-gray-700 px-4 py-2 rounded-md font-medium transition-all duration-300 flex items-center gap-2"
              onClick={handleCancelEdit}
            >
              <Close />
              <span>Hủy</span>
            </button>
          </div>
        </div>
      ) : (
        // Display mode
        <div className="flex justify-between items-center px-4">
          <div className="flex items-center gap-6">
            <span className="text-lg font-semibold text-gray-900 min-w-20">
              {schedule.time}
            </span>
            <span className="text-base font-medium text-blue-600 bg-blue-100 px-3 py-1 rounded-full">
              {schedule.value}%
            </span>
          </div>
          <div className="flex gap-2">
            <button 
              className="text-blue-600 hover:text-blue-700 hover:bg-blue-50 px-3 py-2 rounded-md transition-all duration-300 flex items-center gap-2 text-sm font-medium"
              onClick={() => handleEdit(index)}
            >
              <Edit />
              <span>Sửa</span>
            </button>
            <button 
              className="text-red-600 hover:text-red-700 hover:bg-red-50 px-3 py-2 rounded-md transition-all duration-300 flex items-center gap-2 text-sm font-medium"
              onClick={() => handleDelete(index)}
            >
              <Trash />
              <span>Xóa</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Card;
